/* lib/demoLead.js — чистая логика анкеты демо-стенда (CJM «анкета → /signup»).
 * Реестры enum'ов heard_from/goals (байт-в-байт с бэком /api/demo/lead/), маппинг
 * error-конверта в ошибки полей формы и безопасный парс sessionStorage-хэндоффа
 * (DEMO_SIGNUP_STORAGE_KEY из lib/api/demo.js). Держим вне JSX ради vitest
 * (см. demoLead.test.js); потребители — LeadRequestModal / SignUp / SignIn. */

// «Откуда о нас узнали» — enum heard_from бэка (значения байт-в-байт с контрактом).
// Плейсхолдер «— выберите —» НЕ здесь: реестр = только легальные значения enum'а.
export const HEARD_OPTIONS = [
  { value: 'recommendation', label: 'Рекомендация' },
  { value: 'search', label: 'Поиск' },
  { value: 'social', label: 'Соцсети' },
  { value: 'telegram', label: 'Telegram' },
  { value: 'article', label: 'Статья/блог' },
  { value: 'other', label: 'Другое' },
];

// «Что хотите контролировать» — enum goals бэка (multi-pick чипами).
export const GOAL_OPTIONS = [
  { value: 'foodcost', label: 'Фудкост' },
  { value: 'menu', label: 'Анализ меню' },
  { value: 'aggregators', label: 'Агрегаторы доставки' },
  { value: 'purchases', label: 'Закупки' },
  { value: 'staff', label: 'Официанты и ФОТ' },
  { value: 'other', label: 'Другое' },
];

// DRF field-errors {field:[msgs]} → ключи стейта err формы (consent живёт на чекбоксе agree).
const FIELD_ERR_MAP = [
  ['name', 'name'], ['phone', 'phone'], ['email', 'email'], ['telegram', 'telegram'],
  ['pos', 'pos'], ['comment', 'comment'], ['heard_from', 'heard'], ['goals', 'goals'],
  ['consent', 'agree'],
];

const GENERIC_MESSAGE = 'Не удалось отправить анкету. Попробуйте ещё раз.';
const RATE_MESSAGE = 'Слишком много попыток — подождите минуту и попробуйте снова.';

// Error-конверт /api/demo/lead/ → форма. Возвращает РОВНО одно из двух:
//   { fieldErrors: {<ключ формы>: msg}, message: null } — показать под полями;
//   { fieldErrors: null, message: str }                 — показать тостом.
// Ветки: 400 DRF {field:[msgs]} и {field:'str'}; легаси {code:'phone_required',detail};
// 400 non_field_errors/detail-only → message; 429 → rate-message; прочее → generic.
export function mapLeadFormErrors(status, data) {
  const d = (data && typeof data === 'object' && !Array.isArray(data)) ? data : {};
  if (status === 400) {
    const fieldErrors = {};
    for (const [apiKey, errKey] of FIELD_ERR_MAP) {
      const v = d[apiKey];
      if (Array.isArray(v) && typeof v[0] === 'string') fieldErrors[errKey] = v[0];
      else if (typeof v === 'string') fieldErrors[errKey] = v;
    }
    // легаси-форма {code:'phone_required', detail} — DRF-ошибка phone важнее
    if (d.code === 'phone_required' && !fieldErrors.phone) {
      fieldErrors.phone = d.detail || 'Укажите телефон для связи.';
    }
    if (Object.keys(fieldErrors).length) return { fieldErrors, message: null };
    const nonField = Array.isArray(d.non_field_errors) && typeof d.non_field_errors[0] === 'string'
      ? d.non_field_errors[0] : '';
    return { fieldErrors: null, message: d.detail || nonField || GENERIC_MESSAGE };
  }
  if (status === 429) {
    return { fieldErrors: null, message: (typeof d.detail === 'string' && d.detail) || RATE_MESSAGE };
  }
  return { fieldErrors: null, message: (typeof d.detail === 'string' && d.detail) || GENERIC_MESSAGE };
}

// Безопасный парс sessionStorage-хэндоффа {token, email, name}. Любой мусор
// (null, не-JSON, не-объект, пустой/нестроковый token) → null; email/name
// нормализуются в строки — консьюмеры кладут их прямо в value инпутов.
export function parseDemoSignupStorage(raw) {
  if (typeof raw !== 'string' || !raw) return null;
  let d;
  try { d = JSON.parse(raw); } catch { return null; }
  if (!d || typeof d !== 'object' || Array.isArray(d)) return null;
  if (typeof d.token !== 'string' || !d.token) return null;
  return {
    token: d.token,
    email: typeof d.email === 'string' ? d.email : '',
    name: typeof d.name === 'string' ? d.name : '',
  };
}
